export default __webpack_public_path__ + "static/media/chuva-sol.d3f6e60c.svg";